import { useCallback } from 'react';

import { DUGOUT_SEND_ACTION_EVENT, DugoutLocations } from '@/constants/chromeExtension';
import { BillingReportRow } from '@/pages/BillingReportResults/types';
import type { DugoutSendActionEvent } from '@/types/chromeExtension';
import { ENCOUNTER_TYPES } from '@/types/encounter';

export const SERVICE_CLASS_TO_ENCOUNTER_TYPE: Record<string, ENCOUNTER_TYPES> = {
  Appointment: ENCOUNTER_TYPES.APPOINTMENT_ATTENDANCE,
  'Drug Screen': ENCOUNTER_TYPES.DRUG_SCREEN,
  Chart: ENCOUNTER_TYPES.FORM_ANSWER_GROUP,
  'Case Rate': ENCOUNTER_TYPES.CASE_RATE_BILLING_PERIOD,
  'Add On': ENCOUNTER_TYPES.ADD_ON
};

/**
 * Keeps the Chrome extension's Dugout panel pointed at the encounter behind the
 * billing row a user has selected. Any grid of billing rows should call this on
 * selection change so the panel follows along in every billing view.
 */
const useDugoutBillingRowSelection = () => {
  const showSelectedRowInDugout = useCallback((rows: BillingReportRow[]) => {
    // Only an unambiguous selection identifies an encounter to navigate to.
    if (rows.length !== 1) return;

    const [{ service_class: serviceClass, service_id: serviceId }] = rows;
    const encounterType = SERVICE_CLASS_TO_ENCOUNTER_TYPE[serviceClass];
    if (!serviceId || !encounterType) return;

    window.dispatchEvent(
      new CustomEvent<DugoutSendActionEvent>(DUGOUT_SEND_ACTION_EVENT, {
        detail: {
          destination: DugoutLocations.ENCOUNTER_BILLING,
          data: { encounterId: serviceId, encounterType }
        }
      })
    );
  }, []);

  return { showSelectedRowInDugout };
};

export default useDugoutBillingRowSelection;
